import { render, staticRenderFns } from "./WelcomeSupportTeam.vue?vue&type=template&id=0e4e773c&"
import script from "./WelcomeSupportTeam.vue?vue&type=script&lang=js&"
export * from "./WelcomeSupportTeam.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeSupportTeam.vue?vue&type=style&index=0&id=0e4e773c&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports